import BaseComponent from "../../../baseComponent.js";
import styles from "./styles.scss";

export default class Label extends BaseComponent {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={styles.configLineWrapper}>
        <div className={styles.configLine}>
          <div className={styles.configLabel}>{this.props.text || "Label"}</div>
          <input type="text"
                 placeholder="Enter Label"
                 value={this.props.label} onChange={(e) => this.props.onLegendChange("legendLabel", e.target.value)}/>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/label.jsx